export const getCpasList = (filteredVisuals, isROAS) => {
  if (!filteredVisuals) return [];
  return [...filteredVisuals]
    .filter((visual) => visual.results > 0)
    .map(({ cpa }) => (isROAS ? (cpa > 0 ? 1 / cpa : 0) : cpa));
};
